/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import ProductItemLayoutForm from './product-item-layout-form';
import ProductLabelForm from './product-item-label-form';
import ProductPriceForm from './product-item-price-form';
import ProductItemSwatchForm from './product-item-swatch-form';
import ProductItemAddToCartBtnForm from './product-item-add-to-cart-button-form';
import ProductItemQuickViewBtnForm from './product-item-quick-view-button-form';
import ProductItemAdditionalInfoForm from './product-item-additional-info-form';
import ProductItemCallToActionForm from './product-item-call-to-action-form';
import ProductListLayoutForm from './product-list-layout-form';
import ProductListCollectionHeaderForm from './product-list-collection-header-form';
import ProductListBreadcrumbsForm from './product-list-breadcrumbs-form';
import ProductListToolBarForm from './product-list-tool-bar-form';
import ProductListPaginationForm from './product-list-pagination-form';
import QuickViewForm from './quick-view-form';
import AjaxCartForm from './ajax-cart-form';
import AdvancedColorForm from './advanced-color-form';
import ColorForm from './color-form';
import TypographyForm from './typography-form';
import TypographySectionForm from './typography-section-form';

import { MENU_ITEM_VALUE } from 'src/constants/theme-settings';
import { MENU_ID } from 'src/constants/theme-settings.jsx';

type Props = {
  activeMenuItem: string,
  formValues: any,
  filterDataOptions: any[],
  currentAppReviewIntegration: string,
  themeSettingDefaultValue: any,
  themeSettingDefaultThemeValue: any,
  labelTranslation: any,
  boostThemeLibName: string,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class GeneralForm extends Component<ComposedProps> {
  MappingForm = {
    [MENU_ITEM_VALUE.PRODUCT_ITEM_LAYOUT]: ProductItemLayoutForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_LABEL]: ProductLabelForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_PRICE]: ProductPriceForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_SWATCHES]: ProductItemSwatchForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_ADD_TO_CART_BTN]: ProductItemAddToCartBtnForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_QUICK_VIEW_BTN]: ProductItemQuickViewBtnForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_ADDITIONAL_INFO]: ProductItemAdditionalInfoForm,
    [MENU_ITEM_VALUE.PRODUCT_ITEM_CALL_TO_ACTION]: ProductItemCallToActionForm,

    [MENU_ITEM_VALUE.PRODUCT_LIST_LAYOUT]: ProductListLayoutForm,
    [MENU_ITEM_VALUE.PRODUCT_LIST_COLLECTION_HEADER]: ProductListCollectionHeaderForm,
    [MENU_ITEM_VALUE.PRODUCT_LIST_BREADCRUMBS]: ProductListBreadcrumbsForm,
    [MENU_ITEM_VALUE.PRODUCT_LIST_TOOLBAR]: ProductListToolBarForm,
    [MENU_ITEM_VALUE.PRODUCT_LIST_PAGINATION]: ProductListPaginationForm,
    [MENU_ITEM_VALUE.ADVANCED_SETTINGS_QUICK_VIEW]: QuickViewForm,
    [MENU_ITEM_VALUE.ADVANCED_SETTINGS_AJAX_CART]: AjaxCartForm,

    [MENU_ITEM_VALUE.COLOR]: ColorForm,
    [MENU_ITEM_VALUE.ADVANCED_COLOR]: AdvancedColorForm,
    [MENU_ITEM_VALUE.TYPOGRAPHY]: TypographyForm,
    [MENU_ITEM_VALUE.TYPOGRAPHY_HEADING]: TypographySectionForm,
    [MENU_ITEM_VALUE.TYPOGRAPHY_BODY]: TypographySectionForm,
    [MENU_ITEM_VALUE.TYPOGRAPHY_BUTTON]: TypographySectionForm,
    [MENU_ITEM_VALUE.TYPOGRAPHY_LINK_ACCENT]: TypographySectionForm
  };

  getSpecificForm = () => {
    const { activeMenuItem } = this.props;
    return this.MappingForm[activeMenuItem];
  };

  convertPrefixToV3 = () => {
    const { activeMenuItem } = this.props;
    const MAP_PREFIX = {
      [MENU_ITEM_VALUE.PRODUCT_ITEM_LAYOUT]: MENU_ID.PRODUCT_ITEM
    };

    return MAP_PREFIX[activeMenuItem] || activeMenuItem;
  };

  render() {
    const {
      updateField,
      filterDataOptions,
      formValues,
      commonSetting,
      currentAppReviewIntegration,
      themeSettingDefaultValue,
      themeSettingDefaultThemeValue,
      labelTranslation,
      boostThemeLibName,
      updateFieldReducer,
      activeMenuItem
    } = this.props;
    const SpecificForm = this.getSpecificForm();
    if (!SpecificForm) {
      return null;
    }

    const prefix = this.convertPrefixToV3();
    return (
      <SpecificForm
        commonSetting={commonSetting}
        prefix={prefix}
        updateField={updateField}
        formValues={formValues}
        filterDataOptions={filterDataOptions} // For swatch item
        currentAppReviewIntegration={currentAppReviewIntegration} // For rating
        themeSettingDefaultValue={themeSettingDefaultValue}
        themeSettingDefaultThemeValue={themeSettingDefaultThemeValue}
        labelTranslation={labelTranslation} // For placeholder in form
        boostThemeLibName={boostThemeLibName} // For view as component options
        updateFieldReducer={updateFieldReducer}
        activeMenuItem={activeMenuItem}
      />
    );
  }
}

export default withI18n()(GeneralForm);
